import React from 'react';
import PaginaInfoPage from './PaginaInfoPage';

/** /planes: precio y qué incluye el plan (contenido en src/content/paginasInfo.ts). */
const PlanesPage: React.FC = () => <PaginaInfoPage pagina="planes" />;

export default PlanesPage;
